import { FieldPermissionsContext } from "../../components/common/field-permissions/FieldPermissionsContext";
import { useContext } from "react";
export const useProtectedFieldAccessLevel = (name: string) => {
  const context = useContext(FieldPermissionsContext);
  const permission = context.fieldPermissions?.find((x) => x.name === name);
  return permission?.fieldAccessLevel;
};
